import { CompanyPolicyVersionHistoryModel } from './companyPolicyVersionHistoryModel';

export class EditCompanyPolicyVersionHistoryModel extends CompanyPolicyVersionHistoryModel {
public versionFile: File;
public companyPolicyId: number;
}
